export const inicializarCanvas = (canvasWidth, canvasHeight) => {
  const canvas = document.createElement("canvas");
  canvas.width = canvasWidth;
  canvas.height = canvasHeight;
  const context = canvas.getContext("2d");
  context.fillStyle = "white";
  context.fillRect(0, 0, canvas.width, canvas.height);
  context.fillStyle = "black";

  return context;
};

export const agregarTituloComprobante = (context, y) => {
  context.font = "bold 45px Arial";
  const canvasWidth = context.canvas.width;
  
  const titulo = "COMPROBANTE";
  const tituloWidth = context.measureText(titulo).width;
  context.fillText(titulo, (canvasWidth - tituloWidth) / 2, y);
  
  y += 20;
  context.moveTo(1, y);
  context.lineTo(10000, y);
  context.stroke();
  y += 30;

  return y;
};

export const agregarArticulosComprobante = (context, articulos, y) => {
  context.font = "bold 25px Arial";
  context.fillText("Descripción", 5, y);
  y += 35;
  context.fillText("Cantidad", 5, y);
  context.fillText("Precio Unit.", 220, y);
  context.fillText("Total", 440, y);
  y += 10;
  context.moveTo(1, y);
  context.lineTo(20000, y);
  context.stroke();
  y += 30;

  if (articulos && articulos.length > 0) {
    context.font = "28px Arial";
    articulos.forEach(articulo => {
      const maxWidth = 550;

      // Verificar si el nombre del artículo excede el ancho máximo
      if (context.measureText(articulo.descripcion).width > maxWidth) {
        const words = articulo.descripcion.split(" ");
        let line = "";
        let lines = [];
        for (let i = 0; i < words.length; i++) {
          const testLine = line + words[i] + " ";
          const testWidth = context.measureText(testLine).width;
          if (testWidth > maxWidth) {
            lines.push(line);
            line = words[i] + " ";
          } else {
            line = testLine;
          }
        }
        lines.push(line);

        // Dibujar las líneas en el canvas
        for (let i = 0; i < lines.length; i++) {
          context.fillText(lines[i], 5, y);
          y += 40;
        }
      } else {
        context.fillText(articulo.descripcion, 5, y);
        y += 40;
      }

      const cantidad = articulo.cantidadArticulo || articulo.cantidad || 0;
      const precioUnitario = articulo.importe / cantidad;
      
      context.fillText(cantidad.toFixed(2), 5, y);
      context.fillText(precioUnitario.toFixed(2), 220, y);
      context.fillText(articulo.importe.toFixed(2), 415, y);
      y += 40;
    });
  } else {
    console.log("No hay artículos para mostrar.");
  }

  return y;
};

export const agregarTotalComprobante = (context, total, y) => {
  y += 20;
  context.moveTo(1, y);
  context.lineTo(20000, y);
  context.stroke();
  y += 40;
  
  context.font = "bold 30px Arial";
  context.fillText("TOTAL:", 5, y);
  context.font = "bold 35px Arial";
  context.fillText(`$${parseFloat(total).toFixed(2)}`, 380, y);
  
  y += 60;
  return y;
};

export const agregarMensajeFinal = (context, y) => {
  const canvasWidth = context.canvas.width;
  context.font = "bold 30px Arial";
  
  const mensaje = "¡Gracias por su compra!";
  const mensajeWidth = context.measureText(mensaje).width;
  context.fillText(mensaje, (canvasWidth - mensajeWidth) / 2, y);
  
  y += 40;
  return y;
};

export const imprimirComprobante = async (facturaInfo) => {
  try {
    const canvasWidth = 575;
    const canvasHeight = 4000;
    const context = inicializarCanvas(canvasWidth, canvasHeight);

    let y = 50;

    // Agregar título
    y = agregarTituloComprobante(context, y);
    
    y += 20;

    // Agregar artículos
    y = agregarArticulosComprobante(context, facturaInfo.articulos, y);

    // Agregar total
    y = agregarTotalComprobante(context, facturaInfo.total, y);

    // Agregar mensaje final
    y = agregarMensajeFinal(context, y);

    // Ajustar altura final del canvas
    const canvas = context.canvas;
    const finalHeight = y + 50;
    const finalCanvas = document.createElement("canvas");
    finalCanvas.width = canvasWidth;
    finalCanvas.height = finalHeight;
    const finalContext = finalCanvas.getContext("2d");
    finalContext.fillStyle = "white";
    finalContext.fillRect(0, 0, finalCanvas.width, finalCanvas.height);
    finalContext.drawImage(canvas, 0, 0);

    // Imprimir
    const dataURL = finalCanvas.toDataURL("image/png");
    const base64Data = dataURL.replace(/^data:image\/png;base64,/, "");
    
    console.log("IMAGEN A IMPRIMIR");
    console.log(base64Data);
    
    if (!(window.location.hostname === "localhost" && window.location.port === "3000")) {
      window.MyInterface.imprimirFacturaAfip(base64Data);
    }

    return true;
  } catch (error) {
    console.error("Error al imprimir comprobante:", error);
    return false;
  }
};
